(function componentForm($, Adzuki)
{
	'use strict';

	var form = {
		name: 'HotelBookingAddPayment',
	};

	var label_name     = 'hotelbookingaddpayment-';

	$(document).ready(function documentReady()
	{
		Adzuki.Form.registerForm(form);
	});

	form.load = function load()
	{
		var responsible_client = $('#' + label_name + 'client_id');
		var choose_cc          = $('#' + label_name + 'client_credit_card_id');
		var selected_cc_widget = $('.selected-cc');
		var cardholder_country = $('#' + label_name + 'cardholder_country_id');
		var cardholder_state   = $('#' + label_name + 'cardholder_state_id');
		var selected_client_id = responsible_client.data('selected-client');
		var client_is_external = true;

		// when the resposible client changes
		responsible_client.change(function onResponsibleClientChange()
		{
			var client_id = $(this).val();

			if (client_id === 'new|0') {
				return;
			}

			hideAllCCFields();
			hideErrorHighlights();

			// show typeahead to search for a client
			if (client_id === 'existing') {
				$('.existing-client').toggleClass('hidden');
				$('.responsible-client').toggleClass('hidden');

				truncateCCOptions();
				choose_cc.attr('disabled', true);
				return;
			}

			// new client, no cc's on it yet since it doesn't exist yet
			if (client_id === 'new' || client_id === '') {
				truncateCCOptions();
				choose_cc.attr('disabled', true);
				return;
			}

			if (client_id) {
				populateClientCreditCards(client_id);
				populateClientAddresses(client_id);
			}
		});

		choose_cc.change(function onCreditCardChange()
		{
			var credit_card_id = $(this).val();
			var url            = '/ClientCreditCards/get/' + credit_card_id;
			var existing_cc_id = choose_cc.data('selected-cc');
			var secure_tokens  = [];

			hideErrorHighlights();

			if (credit_card_id) {
				if (!existing_cc_id) {
					$('#' + label_name + 'cardholder_name').val('').focus();
					$('#' + label_name + 'credit_card_type_id').val('').trigger('change');
					$('#' + label_name + 'credit_card_number').val('');
					$('#' + label_name + 'credit_card_expiration_month').val('');
					$('#' + label_name + 'credit_card_expiration_year').val('');
					$('#' + label_name + 'cardholder_address1').val('');
					$('#' + label_name + 'cardholder_address2').val('');
					$('#' + label_name + 'cardholder_city').val('');
					$('#' + label_name + 'cardholder_state_id').val('');
					$('#' + label_name + 'cardholder_country_id').val('');
					$('#' + label_name + 'cardholder_zipcode').val('');

					if (typeof $('#' + label_name + 'credit_card_security_code').data('disabled') === 'undefined') {
						$('#' + label_name + 'credit_card_security_code').val('');
					}
				}

				if (credit_card_id === 'new') {
					// If add credit card is checked, uncheck it
					if ($('#' + label_name + 'add_credit_card').is(':checked')) {
						$('#' + label_name + 'add_credit_card').trigger('click');
					}

					// show all CC fields except for update
					$('.existing-cc-fields').removeClass('hidden');
					$('.cc-fields').removeClass('hidden');
					$('.add-credit-card').removeClass('hidden');
					$('.make-primary-cc').removeClass('hidden');
					$('.update-cc').addClass('hidden');

					$('#' + label_name + 'credit_card_number').removeAttr('data-token');
					$('#' + label_name + 'credit_card_security_code').removeAttr('data-ccv_token');
					$('#' + label_name + 'credit_card_security_code').removeAttr('data-ccv_expiration');

					$('.cc-num-ss-link').addClass('hidden');
					$('.cc-num-span').removeClass('input-group');

					// hide selected CC details (if visible)
					selected_cc_widget.empty().addClass('hidden');

					// If payment data is in the session, use the data from there
					// unless it's explicitly changed in the form
					if (existing_cc_id) {
						cardholder_country.trigger('change');
						$('#' + label_name + 'credit_card_type_id').trigger('change');
						$('#' + label_name + 'add_credit_card').trigger('change');
					}

					return;
				}

				// If update credit card is unchecked, recheck it
				if (!$('#' + label_name + 'update_credit_card').is(':checked')) {
					$('#' + label_name + 'update_credit_card').trigger('click');
				}

				// show existing CC fields
				$('.existing-cc-fields').removeClass('hidden');

				// show address fields, but hide checkboxes to add the CC and show the update CC checkbox
				$('.cc-fields').removeClass('hidden');
				$('.add-credit-card').addClass('hidden');
				$('.make-primary-cc').addClass('hidden');
				$('.update-cc').removeClass('hidden');

				// populate existing CC fields
				Adzuki.Ajax.get(url + '/1').then(function getCreditCardSuccess(credit_card)
				{
					var exp_date  = moment(credit_card.expiration, 'YYYY-MM-DD');
					var exp_year  = exp_date.year();
					var exp_month = exp_date.month() + 1;

					// If payment data is in the session, use the data from there
					// unless it's explicitly changed in the form
					if (existing_cc_id) {
						if (credit_card.number_token !== null) {
							$('.cc-num-span').addClass('input-group');
							$('.cc-num-ss-link').removeClass('hidden');

							$('#' + label_name + 'credit_card_number').attr('data-token', credit_card.number_token);
						}

						cardholder_country.trigger('change');
						$('#' + label_name + 'credit_card_type_id').trigger('change');
						return;
					}

					$('#' + label_name + 'cardholder_name').val(credit_card.name);
					$('#' + label_name + 'credit_card_type_id').val(credit_card.credit_card_type_id);
					$('#' + label_name + 'credit_card_type_id').trigger('change');
					$('#' + label_name + 'credit_card_number').val('');

					if (typeof $('#' + label_name + 'credit_card_security_code').data('disabled') === 'undefined') {
						$('#' + label_name + 'credit_card_security_code').val('');
					}

					if (credit_card.number_token === null) {
						$('#' + label_name + 'credit_card_number').removeAttr('data-token');
						$('#' + label_name + 'credit_card_security_code').removeAttr('data-ccv_token');
						$('#' + label_name + 'credit_card_security_code').removeAttr('data-ccv_expiration');

						$('.cc-num-ss-link').addClass('hidden');
						$('.cc-num-span').removeClass('input-group');

						$('#' + label_name + 'credit_card_number').val('').focus();
					} else {
						$('.cc-num-span').addClass('input-group');
						$('.cc-num-ss-link').removeClass('hidden');

						$('#' + label_name + 'credit_card_number').attr('data-token', credit_card.number_token);
						$('#' + label_name + 'credit_card_security_code').attr('data-ccv_token', credit_card.ccv_token);
						$('#' + label_name + 'credit_card_security_code').attr('data-ccv_expiration', credit_card.ccv_token_expiration);

						secure_tokens[0] = credit_card.number_token;

						if (credit_card.ccv_token !== '' && credit_card.ccv_token !== null) {
							secure_tokens[1] = credit_card.ccv_token;
						}

						Adzuki.SecureStorage.detokenize({
							secure_storage_tokens: secure_tokens,
							success              : function success(plain_texts) {
								$('#' + label_name + 'credit_card_number').val(plain_texts[0]);

								if (plain_texts.length === 2) {
									$('#' + label_name + 'credit_card_security_code').val(plain_texts[1]);

									$('.security-code-value').html(plain_texts[1]);
									$('.security-code-row').removeClass('hidden');
								}
							}
						});
					}

					$('#' + label_name + 'credit_card_expiration_month').val(exp_month);
					$('#' + label_name + 'credit_card_expiration_year').val(exp_year);

					// prepopulate any avaialable address fields
					if (credit_card.address1) {
						$('#' + label_name + 'cardholder_address1').val(credit_card.address1);
					}

					if (credit_card.address2) {
						$('#' + label_name + 'cardholder_address2').val(credit_card.address2);
					}

					if (credit_card.city) {
						$('#' + label_name + 'cardholder_city').val(credit_card.city);
					}

					if (parseInt(credit_card.country_id)) {
						$('#' + label_name + 'cardholder_country_id').val(credit_card.country_id);

						if (parseInt(credit_card.state_id)) {
							Adzuki.Address.countryChange(
								$('#' + label_name + 'cardholder_country_id'),
								credit_card.state_id
							);
						} else {
							Adzuki.Address.countryChange(
								$('#' + label_name + 'cardholder_country_id')
							);
						}
					}

					if (credit_card.zip) {
						$('#' + label_name + 'cardholder_zipcode').val(credit_card.zip);
					}
				});

				// show CC info
				Adzuki.Ajax.get(url).then(function getCreditCardSuccess(credit_card)
				{
					selected_cc_widget.empty()
									  .removeClass('hidden')
									  .append(credit_card);
				});

			} else {
				// hide CC fields
				$('.existing-cc-fields').addClass('hidden');
				$('.cc-fields').addClass('hidden');

				// hide CC details widget
				selected_cc_widget.addClass('hidden').empty();
			}
		});

		// When choosing a "Same as" address
		$('#' + label_name + 'client_address_id').change(function onClientAddressChange(event) {
			var address_id = $(this).val();

			if (address_id.length > 0) {
				Adzuki.Ajax.get('/ClientAddresses/_ajaxGetAddress/' + address_id)
				.then(function onGetAddressSuccess(response) {
					if (response) {
						$('#' + label_name + 'cardholder_address1').val(response.address1);
						$('#' + label_name + 'cardholder_address2').val(response.address2);
						$('#' + label_name + 'cardholder_city').val(response.city);
						$('#' + label_name + 'cardholder_state_id').val(response.state_id);
						$('#' + label_name + 'cardholder_country_id').val(response.country_id);
						$('#' + label_name + 'cardholder_zipcode').val(response.zip);

						Adzuki.Address.countryChange(
							$('#' + label_name + 'cardholder_country_id'),
							response.state_id
						);
					}
				});
			} else {
				$('#' + label_name + 'cardholder_address1').val('');
				$('#' + label_name + 'cardholder_address2').val('');
				$('#' + label_name + 'cardholder_city').val('');
				$('#' + label_name + 'cardholder_state_id').val('');
				$('#' + label_name + 'cardholder_country_id').val('');
				$('#' + label_name + 'cardholder_zipcode').val('');
			}
		});

		// when the select drop down of cardholder country changes
		cardholder_country.change(function onCountryChange()
		{
			var state_id;

			// pre-select the state only if modifying a payment
			if (cardholder_state.data('selected-state') !== '') {
				state_id = cardholder_state.data('selected-state');
				cardholder_state.data('selected-state', '');
			}

			Adzuki.Address.countryChange($(this), state_id);
		});

		// clicking on the close button to reset the client typeahead
		$('.close-client-typeahead').click(function onCloseTypeahead(event) {
			event.preventDefault();

			$('.existing-client').toggleClass('hidden');
			$('.responsible-client').toggleClass('hidden');

			$('#' + label_name + 'existing_client_id').val('');
			$('.existing-client-typeahead').val('');

			responsible_client.val('');
			responsible_client.trigger('change');

			truncateCCOptions();
			choose_cc.attr('disabled', true);
		});

		// setup existing client typeahead
		if ($('.existing-client-typeahead').length > 0) {
			Adzuki.Typeahead(
				$('.existing-client-typeahead'),
				'/Searches/client/',
				function select(item, $self, typeahead) {
					if (item.id) {
						typeahead.setHiddenValue(item.id);

						hideAllCCFields();
						populateClientCreditCards(item.id);
						populateClientAddresses(item.id);
					} else {
						$('.existing-client-typeahead').val('');
					}
				}
			);
		}

		// checking Add CC to client profile checkbox
		$('#' + label_name + 'add_credit_card').change(function onAddToProfileChange(event) {
			var is_checked            = $(this).is(':checked');
			var make_primary_checkbox = $('#' + label_name + 'make_primary');

			if (Adzuki.app === 'Web') {
				return;
			}

			make_primary_checkbox.prop('disabled', !is_checked);

			if (!is_checked) {
				make_primary_checkbox.prop('checked', false);
			}
		});

		// when selecting a responsible client that is not part of the booking
		if (selected_client_id && typeof selected_client_id === 'string' && selected_client_id.indexOf('new') === -1) {
			responsible_client.find('option').each(function onEachOption(index, el) {
				var client_id = $(el).val();

				if (
					client_id
					&& client_id !== 'existing'
					&& parseInt(client_id) === selected_client_id
				) {
					client_is_external = false;
					return false;
				}
			});

			// Agent used a client that is not part of the booking
			// Select this external client and trigger events/populate cards and addresses
			if (client_is_external) {
				responsible_client.val('existing');
				responsible_client.trigger('change');

				// set hidden field value
				$('#' + label_name + 'existing_client_id').val(selected_client_id);

				// client name and email on client search text field
				if ($('#' + label_name + 'existing_client_search').data('selected-client-name')) {
					$('#' + label_name + 'existing_client_search').val(
						$('#' + label_name + 'existing_client_search').data('selected-client-name')
					);
				}

				populateClientCreditCards(selected_client_id);
				populateClientAddresses(selected_client_id);
			} else {
				// trigger responsible client change
				responsible_client.trigger('change');
			}
		} else {
			// trigger responsible client change
			responsible_client.trigger('change');
		}

		// trigger cc change
		choose_cc.trigger('change');

		function hideAllCCFields()
		{
			$('.existing-cc-fields').addClass('hidden');
			$('.cc-fields').addClass('hidden');
			selected_cc_widget.empty().addClass('hidden');
		}

		function hideErrorHighlights()
		{
			$('.existing-cc-fields .form-group').removeClass('has-error');
			$('.cc-fields .form-group').removeClass('has-error');
		}

		function populateClientAddresses(client_id)
		{
			$('#' + label_name + 'client_address_id')
				.empty()
				.append('<option selected="1"></option>');

			if (client_id) {
				Adzuki.Ajax.get('/ClientAddresses/getAddressesByClientId/' + client_id)
				.then(function success(response) {
					$.each(response, function parseAddresses(address_id, address) {
						var markup = '';
						markup += '<option value="' + address_id + '">';
						markup += address;
						markup += '</option>';

						if (address !== '') {
							$('#' + label_name + 'client_address_id').append(markup);
						}
					});
				});
			}
		}

		function populateClientCreditCards(client_id)
		{
			var url            = '/ClientCreditCards/getCardsByClientId/' + client_id + '/0';
			var existing_cc_id = choose_cc.data('selected-cc');

			Adzuki.Ajax.get(url).then(function onCreditCardsSuccess(credit_cards)
			{
				truncateCCOptions();

				$.each(credit_cards, function onEachCreditCard(credit_card_id, credit_card) {
					var markup = '';
					markup += '<option value="' + credit_card_id + '">';
					markup += credit_card;
					markup += '</option>';

					choose_cc.append(markup);
				});

				// pre-select cc when modifying a payment
				if (existing_cc_id) {
					if (existing_cc_id === 'manual') {
						existing_cc_id = 'new';
					}

					choose_cc.val(existing_cc_id);
					choose_cc.trigger('change');

					existing_cc_id = null;
					choose_cc.data('selected-cc', '');
				}
			});
		}

		function truncateCCOptions()
		{
			choose_cc
				.empty()
				.removeAttr('disabled')
				.append('<option selected="1"></option>')
				.append('<option value="new">-- Enter Credit Card Info --</option>');
		}
	};

}(jQuery, window.Adzuki || {}));